/**
 * @overview AvatarTray component
 */
import cx from 'classnames';
import React from 'react';
import { getUniqueKey } from '../../_utils';
import { Avatar } from '../avatar';
import styles from './avatar-tray.module.scss';
const MAX_NUMBER_OF_AVATARS = 3;
export const AvatarTray = ({ id, className, items = [], size = 'm', isNameLink = false, showTooltipOnEllipsis = false, ...restProps }) => {
    if (!items.length)
        return null;
    const avatarItemsToRender = items.slice(0, MAX_NUMBER_OF_AVATARS);
    return (React.createElement("div", { className: cx(className, styles.container, styles[`size-${size}`]), id: id, ...restProps }, avatarItemsToRender.map((item, index) => {
        // Only the first avatar in the avatar tray shows name
        // Display name as first avatar name + number of remaining avatars.
        let suffixText;
        if (index === 0 && items.length !== 1) {
            suffixText = (items.length - 1).toString();
        }
        return (React.createElement(Avatar, { key: getUniqueKey(item), size: size, showName: index === 0, className: styles.avatarTrayItem, name: item.name, suffixText: suffixText, src: item.src, isNameLink: isNameLink, showTooltipOnEllipsis: showTooltipOnEllipsis }));
    })));
};
//# sourceMappingURL=avatar-tray.js.map